import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './styles/article-card.scss.js';

class ArticleCard extends s {
    render() {
        return $ `<a class="article-card" href="${this.href}"><slot name="date"></slot><slot name="title"></slot><div class="tags"><slot name="tag"></slot></div></a>`;
    }
}
ArticleCard.styles = css_248z;
__decorate([
    e({ type: String })
], ArticleCard.prototype, "href", void 0);
customElements.define('article-card', ArticleCard);

export { ArticleCard };
